"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnCloseAttributeFilterDropdownButton = void 0;
var react_1 = require("react");
var sdk_ui_1 = require("@gooddata/sdk-ui");
/**
 * This hook is useful to inject custom onClose to AttributeFilterDropdownButton
 * @internal
 */
exports.useOnCloseAttributeFilterDropdownButton = function (props, onClose) {
    var isOpen = props.isOpen;
    var isOpenPrevious = sdk_ui_1.usePrevious(props).isOpen;
    //This effect is handling onClose callback by checking previous and current open state
    react_1.useEffect(function () {
        if (onClose && isOpenPrevious && !isOpen) {
            onClose();
        }
    }, [onClose, isOpen, isOpenPrevious]);
};
//# sourceMappingURL=useOnCloseAttributeFilterDropdownButton.js.map